{
	"title": "Sensor data",
	"step": "Step",
	"dataOrigin": "Data Origin",
	"lco2Measured": "LCO₂ measured",
	"co2_captured": "CO₂ captured from cement plant",
	"co2_temporarily_stored": "CO₂ in temporary storage",
	"co2_transferred_to_loading_arm": "CO₂ delivered to ship",
	"co2_transferred_to_ship": "CO₂ received in ship",
	"co2_transferred_to_terminal": "CO₂ received at terminal",
	"co2_transferred_to_well": "CO₂ permanently stored"
}
